module.exports = __webpack_public_path__ + "static/media/share_gray.1e10d87a.svg";